class ProductParamsPU {
    constructor({
        pubFrequency,
        pubPrintCirc,
        pubOnLineCirc,
        pubSubscripOptions = '',
    }) {
        this.pubFrequency = pubFrequency
        this.pubPrintCirc = pubPrintCirc
        this.pubOnLineCirc = pubOnLineCirc
        this.pubSubscripOptions = pubSubscripOptions.split(',').map((o) => parseInt(o, 10))
    }

    toJSON = () => ({
        pubFrequency: this.pubFrequency,
        pubPrintCirc: parseInt(this.pubPrintCirc, 10),
        pubOnLineCirc: parseInt(this.pubOnLineCirc, 10),
        pubSubscripOptions: this.pubSubscripOptions.join(','),
    })
}

export default ProductParamsPU
